var rebuyExtension = {
	getProductByID: function(id) {
		var Rebuy = window.Rebuy;
		var $ = Rebuy.libraries.$;
		
		return $.ajax({
			method: 'GET',
			url: 'https://rebuyengine.com/api/v1/products/static',
			data: {
				key: Rebuy.shop.api_key,
				ids: id
			}
		});
		
	},
	initProduct: function(product) {
		var Rebuy = window.Rebuy;
		var Cart = window.Rebuy.Cart;
		
		return Cart.initProduct(product);
	},
	updateInputProduct: function(id) {
		var Rebuy = window.Rebuy;
		var Widget = null;
		
		for (var i = 0; i < Rebuy.widgets.length; i++) {
			if (Rebuy.widgets[i].id == '11950') {
				Widget = Rebuy.widgets[i];
				break;
			}
		}
		
		if (Rebuy && Widget) {
			rebuyExtension.getProductByID(id).then(function(response){
				if (response.data) {
					var product = rebuyExtension.initProduct(response.data[0]);
					
					// Auto select product
					product.selected = true;
					
					// Remove input products
					for (var i = Widget.data.products.length - 1; i >= 0; i--) {
					    if (Widget.data.shopify_product_ids.indexOf(Widget.data.products[i].id) != -1) {
					    	Widget.data.products.splice(i, 1);
					    }
					}
					
					// Set new input product
					Widget.data.metadata.input_products = [product];
					Widget.data.shopify_product_ids = [product.id];
					Widget.data.products.unshift(product);
				}
			});
		}
	}
};


document.addEventListener('compoundProductChange', function(event){
  var product = event.detail.product;
  rebuyExtension.updateInputProduct(product.id);
});